$(document).ready(function () {
  var searchInput = $("#search-input, .DSEH");
  var searchBox = $(".popularse");
  var searchResults = $(".t4s-pa.t4s-frm-search__results");

  function disableScroll() {
    $("body").css("overflow", "hidden");
  }

  function enableScroll() {
    $("body").css("overflow", "");
  }

  function checkAndToggleScroll() {
    if (searchBox.is(":visible") || searchResults.is(":visible")) {
      disableScroll();
    } else {
      enableScroll();
    }
  }

  searchInput.on("input", function () {
    if ($(this).val().length > 0) {
      searchBox.hide();
      searchResults.addClass("xxxxx").show();
    } else {
      searchResults.removeClass("xxxxx").hide();
      searchBox.show();
    }
    checkAndToggleScroll();
  });

  // ✅ Click Event
  searchInput.on("focus click", function () {
    if ($(this).val().trim() === "") {
      searchBox.show();
    } else {
      searchResults.addClass("xxxxx").show();
    }
    checkAndToggleScroll();
  });

  // ✅ Click Outside Event
  $(document).on("click", function (event) {
    if (
      !$(event.target).closest(
        "#search-input, .DSEH, .t4s-pa.t4s-frm-search__results, .popularse"
      ).length
    ) {
      searchResults.removeClass("xxxxx").hide();
      searchBox.hide();
      enableScroll();

      // 🔹 Placeholder wapas dikhane ka logic yaha add kiya
      if (searchInput.val().trim() === "") {
        searchInput.removeClass("no-placeholder");
        searchInput
          .parent(".search-container")
          .find(".placeholder-label.animation")
          .removeClass("notext");
      }
    }
  });

  var observer = new MutationObserver(checkAndToggleScroll);

  observer.observe(searchBox[0], {
    attributes: true,
    attributeFilter: ["style"],
  });
  observer.observe(searchResults[0], {
    attributes: true,
    attributeFilter: ["style"],
  });

  $(document).on("keydown", function (event) {
    if (event.key === "Escape") {
      searchInput.val("");
      searchResults.removeClass("xxxxx").hide();
      searchBox.show();
      enableScroll();

      searchInput.removeClass("no-placeholder");
      searchInput
        .parent(".search-container")
        .find(".placeholder-label.animation")
        .removeClass("notext");
    }
  });

  searchInput.on("input", function () {
    if ($(this).val().length > 0) {
      $(this)
        .addClass("no-placeholder")
        .parent(".search-container")
        .find(".placeholder-label.animation")
        .addClass("notext");
    } else {
      $(this)
        .removeClass("no-placeholder")
        .parent(".search-container")
        .find(".placeholder-label.animation")
        .removeClass("notext");
    }
  });

  $('input[name="gift_"]').on("input", function () {
    $('input[name="properties[Gift]"]').val($(this).val());
  });

  $(".t4s-tab-item a").on("click", function (e) {
    e.preventDefault();
    $(".tab-banner").removeClass("active");
    $("#banner-" + $(this).attr("href").replace("#t4s-", "")).addClass(
      "active"
    );
  });
});
